import React from "react";

import svg from "../../assets/images/icons/logo/white_logo.svg";

export const WhiteLogoIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Appglue"}
    />
);
